<template>
    <div class="phonebox" :class="is_index?'is_index':''" >
        <div class="f-row-start-l" style="align-items:stretch" v-if='phones.length>0'>
            <div class="min-w-33" v-if='phones.length>0'>
                <div class="imgItem pinter w-100 h-100"v-if='i==0' v-for="(item, i) in phones" :key="i" @click="goDetail(item)">
                    <div class="w-100 h-100">
                        <el-image :src="$imgUrl + '/' + item.breviaryMap" class="img1" fit='cover'></el-image>
                    </div>
                    <div class="cont">
                        <p :title="item.pictureTitle" class="overf-elli">{{ item.pictureTitle ? item.pictureTitle : '' }}</p>
                    </div>
                </div>
            </div>
            <div class="min-w-33" v-if='phones.length>1'>
                <div class="imgItem pinter w-100 h-50" v-if='i>0&&i<3' v-for="(item, i) in phones" :key="i" @click="goDetail(item)">
                    <div class="w-100">
                        <el-image :src="$imgUrl + '/' + item.breviaryMap" class="img1" fit='cover'></el-image>
                    </div>
                    <div class="cont">
                        <p :title="item.pictureTitle" class="overf-elli">{{ item.pictureTitle ? item.pictureTitle : '' }}</p>
                    </div>
                </div>
                <div class="imgItem pinter w-100 h-50 f-row-c" v-if='phones.length==1'>
                    没有更多了...
                </div>
            </div>
            <div class="min-w-33" v-if='phones.length>3'>
                <div class="imgItem pinter w-100 h-50" v-if='i>=3' v-for="(item, i) in phones" :key="i" @click="goDetail(item)">
                    <div class="w-100">
                        <el-image :src="$imgUrl + '/' + item.breviaryMap" class="img1" fit='cover'></el-image>
                    </div>
                    <div class="cont f-row-c">
                        <p :title="item.pictureTitle" class="overf-elli">{{ item.pictureTitle ? item.pictureTitle : '' }}</p>
                    </div>
                </div>
                <div class="imgItem pinter w-100 h-50 f-row-c" v-if='phones.length==3'>
                    没有更多了...
                </div>
            </div>
        </div>
        <div class="f-row-c  mb-1" :class="is_index?'mt-2':'mt52'">
            <div class="pr-1" >
                <el-image v-if='param.pageNo!=1' @click="onLeft" :src='require("@/assets/img/icon_left.png")' class="icon pinter"></el-image>
                <div v-else class="icon">
                    <el-image :src='require("@/assets/img/icon_left.png")' class="icon no_click"></el-image>
                </div>
            </div>
            <div class="pl-1" >
                <el-image v-if='!page' @click="onRight" :src='require("@/assets/img/icon_right.png")' class="icon pinter"></el-image>
                <div v-else class="icon">
                    <el-image :src='require("@/assets/img/icon_right.png")' class="icon no_click"></el-image>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'phoneBooks',
    props:['is_index'],
    data() {
        return {
            phones:[],
            param:{
                pageNo:1,//分页
                pageSize:5,
                total: 0,
                isTop:0,
            },
            page:false,
        };
    },

    mounted() {
        this.page=false;
        this.param.pageNo=1;
        this.getList()
    },

    methods: {
        goDetail(item){
            this.$util.goPage('phoneBooksDetail', 7, item.id)
        },
        onLeft(){
            if(this.param.pageNo>1){
                this.page=false;
                this.param.pageNo--
                this.getList()
            }else{

            }
        },
        onRight(){
            if(!this.page){
                this.param.pageNo++
                this.getList()
            }else{
                 this.$message({
                    message: '没有更多了',
                    type: 'warning'
                });
            }

        },
        getList(){
            this.$get('/web/home/getLasBatchList',this.param).then(res=>{
               this.phones=res.result.records;
               this.param.total= res.result.total
               this.$emit('phoneLen',this.phones.length);
               if((this.phones.length<this.param.pageSize)||(this.param.total==this.param.pageSize)){
                   this.page=true
               }else{
                   this.page=false
               }
            })
        }
    },
};
</script>

<style lang="scss" scoped>
.phonebox{
    width: 100%;
    overflow: hidden;
    .min-w-33{
        min-width: 33.33%;
        flex-grow: 1;
        overflow: hidden;
        .imgItem{
            .img1{
                height: 100%;
                width: 100%;
            }
        }
        .h-100{
            height: 100%;
            position: relative;
        }
        .h-50{
            height: 50%;
            overflow: hidden;
            position: relative;
        }
    }
}
.imgItem:hover{
    .img1{
        transform: scale(1.2);
    }
    .cont p{
        transform: scale(1.2);
    }
}
.mt52{
    margin-top: 52px;
}
.cont{
    position: absolute;
    text-align: center;
    width: 100%;
    height: 67px;
    background: rgba(#B5B5B5, 0.67);
    font-size: 24px;
    font-weight: bold;
    bottom: 0px;
    left: 0px;
    padding: 0px 10px;
}
.icon{
    width: 62px;
}
.is_index{
    .cont{
        height: 41px;
        font-size: 14px;
    }
    .icon{
        width: 38px;
    }
    .min-w-33{
        height: 465px;
    }
}
.no_click{
    opacity:0.5;
}
</style>
